import { useState } from "react";
import { useDemo } from "../zustand/DemoZustand";
import { Kreuz, Warnung } from "./Symbole";

/*
  Der Zurücksetzen-Knopf.

  Ohne ihn zeigt der dritte Vorführtermin die Klicks des zweiten. Bewusst
  hinter einem Zahnrad versteckt und mit Rückfrage versehen, damit er im
  Termin nicht versehentlich getroffen wird.
*/
export default function DemoEinstellungen({ aufSchliessen, aufZurueckgesetzt }) {
  const { ich, stammdaten, etwasVeraendert, aktionen } = useDemo();
  const [sicherheitsfrage, setzeSicherheitsfrage] = useState(false);

  async function zuruecksetzen() {
    await aktionen.zuruecksetzen();
    setzeSicherheitsfrage(false);
    aufZurueckgesetzt();
    aufSchliessen();
  }

  return (
    <div className="ueberlagerung" role="dialog" aria-modal="true" aria-label="Demo-Einstellungen">
      <div className="ueberlagerung__karte">
        <div className="ueberlagerung__kopf">
          <h2 style={{ fontSize: "var(--schrift-gross)", marginRight: "auto" }}>Demo</h2>
          <button
            className="knopf knopf--schlicht"
            onClick={aufSchliessen}
            aria-label="Schließen"
          >
            <Kreuz groesse={20} />
          </button>
        </div>

        <dl className="vorlage__daten" style={{ marginTop: "var(--luft-3)" }}>
          <dt>Angemeldet als</dt>
          <dd>
            {ich.name}, {ich.rolle}
          </dd>
          <dt>Fraktion</dt>
          <dd>{stammdaten.gremien["g-fraktion"].name}</dd>
          <dt>Kommune</dt>
          <dd>{stammdaten.koerperschaft.name} (erfunden)</dd>
          <dt>Stand</dt>
          <dd>
            {etwasVeraendert
              ? "In dieser Vorführung wurde etwas verändert."
              : "Ausgangszustand, nichts verändert."}
          </dd>
        </dl>

        <p className="klein leise" style={{ marginTop: "var(--luft-4)" }}>
          Notizen, Meinungsbild, Teilnahme und Aufgaben liegen auf unserem Server und sind
          auf jedem deiner Geräte gleich. Chatbeiträge liegen verschlüsselt bei Matrix — die
          kann auch der Server nicht lesen. Nur der Gelesen-Stand und stumme Kanäle bleiben
          in diesem Browser.
        </p>

        {!sicherheitsfrage ? (
          <button
            className="knopf knopf--zurueckhaltend knopf--breit"
            style={{ marginTop: "var(--luft-4)" }}
            onClick={() => setzeSicherheitsfrage(true)}
            disabled={!etwasVeraendert}
          >
            {etwasVeraendert ? "Demo zurücksetzen" : "Nichts zurückzusetzen"}
          </button>
        ) : (
          <div className="ueberlagerung__warnung">
            <p style={{ display: "flex", gap: "var(--luft-3)", alignItems: "flex-start" }}>
              <Warnung groesse={20} />
              <span>
                <strong>Wirklich zurücksetzen?</strong> Deine Meinungsbilder, deine
                Markierungen und Notizen, Aufgaben und Rückmeldungen werden gelöscht —
                auch auf dem Server. Notizen anderer bleiben.
                <br />
                <strong>Chatbeiträge bleiben stehen.</strong> Sie liegen verschlüsselt bei
                Matrix; sie zurückzuziehen ist noch nicht gebaut.
              </span>
            </p>
            <div className="leiste__knoepfe">
              <button className="knopf" onClick={zuruecksetzen}>
                Ja, zurücksetzen
              </button>
              <button
                className="knopf knopf--zurueckhaltend"
                onClick={() => setzeSicherheitsfrage(false)}
              >
                Abbrechen
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
